// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http'
// import { Observable } from 'rxjs'
// import { switchMap, map, tap } from 'rxjs/operators';


// @Injectable({
//   providedIn: 'root'
// })
// export class FileService {

//   constructor(private httpClient: HttpClient) { }

//   getData(url: string): Observable<string> {
//     return this.httpClient.get(url, { responseType: 'blob' })
//       .pipe(
//         switchMap(response => this.readFile(response))
//       );
//   }

//   private readFile(blob: Blob): Observable<string> {
//     return Observable.create(obs => {
//       const reader = new FileReader();

//       reader.onerror = err => obs.error(err);
//       reader.onabort = err => obs.error(err);
//       reader.onload = () => obs.next(reader.result);
//       reader.onloadend = () => obs.complete();

//       return reader.readAsDataURL(blob);
//     });
//   }

// }









import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {Http, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileService {

  constructor(private http: Http) {}

  downloadFile(url): Observable<any>{
		return this.http.get(url, {responseType: ResponseContentType.Blob});
  }
   
}

